/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import {
	Input,
	Component,
	ChangeDetectionStrategy,
	Self,
	Optional,
	ChangeDetectorRef,
	OnInit,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { MultiWrapperComponent } from '../multi-wrapper/multi-wrapper.component';
import { Observable } from 'rxjs';
import { takeUntil, map } from 'rxjs/operators';

import { TicketEditBaseComponent } from '../ticket-edit-base/ticket-edit-base.component';

import { Variance } from '@touchplan/common';

@Component({
	selector: 'ticket-variance',
	templateUrl: './ticket-variance.component.html',
	// styles: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketVarianceComponent extends TicketEditBaseComponent implements OnInit {
	@Input() public varianceList: Observable<Map<string, Variance>>;
	@Input() public errorOverlapsInput = null;
	@Input() public placeholder = 'Variance Reason';

	public internalList;

	constructor(
		@Self() @Optional() public control: NgControl,
		@Optional() public multiWrapper: MultiWrapperComponent,
		@Optional() protected cd: ChangeDetectorRef
	) {
		super(control, multiWrapper, cd);
	}

	public ngOnInit() {
		super.ngOnInit();

		this.internalList = this.varianceList.pipe(
			map((list) => {
				const varianceMap = new Map();
				list.forEach((thing, id) => {
					varianceMap.set(thing.varianceReason, {
						label: thing.varianceReason,
						value: id,
						number: Number(thing.varianceKey),
						varianceColor: thing.varianceColor,
					});
				});

				return varianceMap;
			})
		);

		this.internalField.valueChanges.pipe(takeUntil(this.shutdownSubject)).subscribe((val) => {
			this.onChange(val);
		});
	}
}
